<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Technician" title="Products" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="row mb-4">
                                <div class="col-md-8">
									<div class="mm-cart-text">
										<table class="product_table">
											<thead style="font-size: medium;">
												<tr>
													<th style="text-align: left; width: 160px;">Technician Name</th>
													<th style="text-align: left;">:</th>
													<td style="text-align: left;">{{ technician.name }}</td>
												</tr> 
											</thead>
										</table>
                                    </div>
								</div>
								<div class="col-md-2">
									<router-link to="/technicians" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                                    <!-- <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
							    </div>
							    <div class="col-md-2">
                                    <router-link :to="{ name: 'add_technician_product', query: { id: technician_id } }" class="btn btn-primary float-end">Add Product</router-link>
							    </div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchTechnicianProducts()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchTechnicianProducts()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Product Name</th>
											<th>Stock</th>
											<th>Updated By</th>
											<th>Last Updated On</th> 
											<th>Action</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(technician_products.length)">
                                        <tr align="center" v-for="(product, index) in technician_products" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
                                            <td>
												{{ product.product_name }}
											</td>
											<td>{{ product.quantity }}</td>
											<td>{{ product.updated_user_name }}</td>
											<td>{{ product.converted_updated_at }}</td>
                                            <td>
												<button class="btn btn-info btn-sm me-2 mb-2" @click="updateStock(product.id)">Update Stock</button><br>                
												<router-link :to="{ name: 'technician_product_logs', query: { id: product.product_id, tc_id: technician_id } }" class="btn btn-primary btn-sm me-2 mb-2">Stock Logs</router-link>
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="5" class="text-center">No products found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchTechnicianProducts(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Type<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="type">
								<option value="">--Select--</option>
								<option value="1">Add Stock</option>
								<option value="2">Remove Stock</option>
							</select>
							<span class="validate-error" v-if="errors.type">
								{{ errors.type[0] }}
							</span>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Stock<span class="text-danger">*</span></label>
                        	<input type="number" v-model="stock" class="form-control" rows="3"/>
							<span class="validate-error" v-if="errors.quantity">
								{{ errors.quantity[0] }}
							</span>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" @click="updateProductStock()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import { Modal } from 'bootstrap';
import DynamicModal from '@/components/dynamic_modal.vue';
import { get, post } from '@/utils/api'
import { routes } from '@/constants/routes';
import { useRoute, useRouter } from 'vue-router';
import Swal from '@/utils/swal';
import { goBack } from '@/utils/urlHider';

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

let dynamicmodal = null;

const showModal = () => {
    if (dynamicmodal) dynamicmodal.show();
};

const hideModal = () => {
    if (dynamicmodal) dynamicmodal.hide();
};

const modal_title = ref("Update Stock");
const button_title = ref("Update");
const keyword = ref("");
const showsearch = ref(false);
const listing_length = ref(10);
const token = ref("");
const errors = ref({});
const type = ref("");
const stock = ref("");
const technician_id = route.query.id;
const technician = ref({});
const technician_products = ref([]);
const update_product_id = ref("");
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

onMounted(() => {
    dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
});

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};

const openModal = () => {
    showModal();
};

const closeModal = () => {
    hideModal();
};

const updateStock = (product_id) => {
	errors.value = {};
    clearForm();
    modal_title.value = "Update Stock";
    button_title.value = "Update";
	update_product_id.value = product_id;
    showModal();
};

const clearForm = () => {
    type.value = "";
    stock.value = "";
    modal_title.value = "Update Stock";
    button_title.value = "Update";
};

const fetchTechnicianProducts = (url = null) => {

	const params = {
		limit: listing_length.value,
		keyword: keyword.value,
		technician_id: technician_id
	}

	const requestUrl = url ?? routes.TechnicianProducts;

	get(requestUrl, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                technician_products.value = response.data.data.technician_products.data;
                technician.value = response.data.data.technician;
				pagination.value = response.data.data.technician_products.links;
				from.value = response.data.data.technician_products.from;
				to.value = response.data.data.technician_products.to;
				total.value = response.data.data.technician_products.total;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', error.response.data.message.technician_id?.[0] || error.response.data.message.limit?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const updateProductStock = () => {

	const formData = new FormData();
	formData.append('technician_product_id', update_product_id.value);
	formData.append('type', type.value);
	formData.append('quantity', stock.value);

	post(routes.UpdateTechnicianProductStock, formData, false)
		.then((response) => {
			if (response.status === 200) {
                Swal.fire('', response.data.message || 'Product stock updated successfully', 'success');
				fetchTechnicianProducts();
				closeModal();
            } else {
                Swal.fire('', response.data.message || 'Failed to update product stock', 'error');
            }
		})
		.catch((error) => {
			if(error.response.status == 422){
    			errors.value = error.response.data.message;
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
}

onMounted(() => {
	fetchTechnicianProducts();
});

</script>

